import { createContext } from 'react';
export var FloatingHeaderContext = /*#__PURE__*/createContext({
  overlayIsOpen: false,
  showHorizontalMenu: false
});